// Package imports:
import React from "react";
// Component imports:
import Modal from "../../ui-elements/Modal/Modal";
import Button from "../../ui-elements/Button/Button";
import Link from "../../ui-elements/Link/Link";

interface IProps {
    show: boolean,
    close(): void,
    submit(): void,
    dataSourceText: string,
    customText?: string | JSX.Element,
    customHeader?: string
};

const SearchConfirmModal: React.FC<IProps> = ({
    show,
    close,
    submit,
    dataSourceText,
    customText,
    customHeader
}) => {
    return (
        <Modal
            className="KCL_search-confirm-modal"
            show={show}
            onHide={close}
            body={
                <>
                    {(customHeader)
                        ? <h3>{customHeader}</h3>
                        : <h3>Kaupa gögn úr {dataSourceText}.</h3>
                    }
                    
                    <div className="infoSection">
                        {
                            (customText)
                            ? customText
                            : (
                                <>
                                Þú ert að fara að kaupa gögn úr {dataSourceText}. Gögn eru samkvæmt
                                <Link className='VerdskraLink' linkSize='18' url="/Verdskra#verdskra/">verðskrá Keldunnar</Link>
                                .
                                </>
                            )
                        }
                        
                    </div>
                    <div className="actions">
                        <Button
                            onClick={close}
                            buttonType='secondary'
                        >
                            Hætta við
                        </Button>
                        <Button
                            onClick={submit}
                        >
                            Halda áfram
                        </Button>
                    </div>
                </>
            }
        />
    );
}

export default SearchConfirmModal;